import React from "react";

const MaintenancePage = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        padding: "20px",
        background: "#f9fafb",
      }}
    >
     
      <h1 style={{ fontSize: "32px", fontWeight: "700", marginBottom: "10px" }}>
        We'll be back soon
      </h1>

      <p style={{ fontSize: "18px", color: "#6b7280", maxWidth: "500px" }}>
        Our system is currently under scheduled maintenance. We’re working hard
        to improve your experience. Please check back shortly.
      </p>

      <p
        style={{
          marginTop: "20px",
          fontSize: "14px",
          color: "#9ca3af",
        }}
      >
        Thank you for your patience 🙏
      </p>
    </div>
  );
};

export default MaintenancePage;